module.exports = __webpack_public_path__ + "img/ExitusC_tipografia.30b1976b.png";